var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-button',{attrs:{"disabled":(_vm.publishmentOrder || {}).paymentStatus !== 'paid'},on:{"click":_vm.click}},[_vm._t("default",[_vm._v("領収証/支払明細書")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }